import { getDefaultTextSimple, getDefaultTextarea } from '../../helpers';

export default {
    name: 'Bloc de texte',
    blocks: {
        title: getDefaultTextSimple("Titre", "Lorem ipsum", 16, "#666"),
        desc: getDefaultTextarea("Description", "Donec laoreet orci eget nulla consectetur, vel accumsan dui fermentum. Donec laoreet orci eget nulla consectetur, vel accumsan dui fermentum. Donec laoreet orci eget nulla consectetur, vel accumsan dui fermentum.Donec laoreet orci eget nulla consectetur, vel accumsan dui fermentum.", null, "#433f3f", null, null, 'center', 16)
    }
};